import { render, staticRenderFns } from "./coreComponent.vue?vue&type=template&id=6f32607a"
import script from "./coreComponent.vue?vue&type=script&lang=js"
export * from "./coreComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports